export const BET_COLOURS = {
  RED: '#9d2837',
  BLACK: '#11142a',
  GREEN: '#384c33',
};
